import 'knockout.validation';
import * as t from 'toastr';
import { Action } from 'history';

class RegisterViewModel {
    public name = ko.observable("");
    public email = ko.observable("");
    public password = ko.observable("");
    public passwordConfirm = ko.observable("");
    public wasValidated = ko.observable("");
    public Errors = ko.validation.group(this);

    constructor() {
        var self = this;
        self.name = ko.observable().extend({ required: true });
        self.email = ko.observable().extend({ required: true, email: true });
        self.wasValidated = ko.observable("");

        self.Errors = ko.validation.group(self);

        // t.error('wtf', '', { closeButton: true });
        //console.warn('w');
    }
    public Clear() {
        var self = this;
        self.name("");
        self.email("");
        self.password("");
        self.passwordConfirm("");
        self.Errors.showAllMessages(false);
        self.wasValidated("");
    }
    public Register() {
        var self = this;
        self.wasValidated("was-validated");
        if (self.Errors().length > 0) {
            console.log(self.Errors().length)
            self.Errors.showAllMessages(true);
            return false;
        }

        //setup return values
        let returndata = {
            displayName: self.name(),
            email: self.email(),
            password: self.password(),
            confirmPassword: self.passwordConfirm()
        }

        fetch(globals.apiUrl + "api/Account/Register", {
            method: "POST",
            body: JSON.stringify(returndata),
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin"
        }).then(function (response) {
            response.status     //=> number 100–599
            response.statusText //=> String
            response.headers    //=> Headers
            response.url        //=> String
            if (response.status == 200) {
                t["success"]("You are now registered.");
                self.Clear();
            }
            else {
            }

            return response.json()
        }, function (error) {
            toastr["error"]("Mail services are currently down. Please try again later. Thank you.");
            console.log(error.message); //=> String
            }).then(function (result: ActionResult) {
                if (!result.succeeded) {
                    //uhh ohh we got errors wait success doesn't post back, this object is bad, maybe we should normalize.
                    console.log("Uhh oh we got errors");
                }
                if (result.errors && result.errors.length>0) {
                    ko.utils.arrayForEach(result.errors, function (error: ErrorCode) {
                        if (error.code == "DuplicateEmail") {
                            t["error"](error.description);
                        }
                    });
                }
                //var test2 = new ActionResult().deserialize(body);
                //console.log(test2.errors.length);
                console.log(result);
            });
        return true;

    }



}

//function api<ActionResult>(url: string): Promise<ActionResult> {
//    return fetch(url)
//        .then(response => {
//            if (!response.ok) {
//                throw new Error(response.statusText)
//            }
//            return response.json()
//        })

//}

class ErrorCode {
    public code:string = "";
    public description:string = "";
    //constructor() {
    //    var self = this;
    //    //self.code = "";
    //    //self.description = "";
    //}
    //deserialize(input: ErrorCode) {
    //    this.code = input.code;
    //    this.description = input.description;
    //    return this;
    //}
}

class ActionResult {
    public succeeded:boolean = false;
    public errors: ErrorCode[] = [];
    public userName: string = "";
    public displayName: string = "";
    public token: string = "";
    //constructor() {
    //    var self = this;
    //    self.succeeded = false;
    //    self.errors = [];
    //}
    //deserialize(input: ActionResult) {
    //    this.succeeded = input.succeeded;
    //    this.errors = input.errors;
    //    return this;
    //}
}

interface Serializable<T> {
    deserialize(input: Object): T;
}


export default { viewModel: RegisterViewModel, template: require('./register.html') };